__turbopack_context__.v({
  "className": "martian_mono_4b2cb401-module__x-k7MG__className",
});
